export default     {
    prompt:"Image Footer",
    field:"linkContainerBackground",
    type:"childStyle",
    property:"background",
    child:".e-link-cont",
    colorPicker:true,
    default:'#000000ff'
}